export default {
      id: "confirmCreateClient-usage",
      viewBox: "0 0 84 84",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#confirmCreateClient",
      toString: function () {
        return this.url;
      }
    }